/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'

import {
  message, Space, Button, Divider, Row, Col, Tooltip,
} from 'antd'

import {
  UploadOutlined, FileImageOutlined, EyeOutlined,
} from '@ant-design/icons'
import { useRecoilState } from 'recoil'

import { userState } from '../../store/atoms'

import { fetch } from '../../utils/fetch'

import ImageModal from './ImageModal'

const UploadButton = ({
  action, orderId, headerId, itemId, created = false, submitted = false, editing,
}) => {
  const [upLoadVisible, setUpLoadVisible] = useState(false)
  const [imageCount, setImageCount] = useState(0)
  const [user, setUser] = useRecoilState(userState)
  const actionUrl = (action !== undefined) && (action !== null) && (action === 'Header')
    ? `/order/${orderId}/header/${headerId}/imageCount`
    : `/order/${orderId}/item/${itemId}/imageCount`

  const getImageCount = async () => {
    await fetch({
      url: actionUrl,
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      if (res?.data?.success) {
        setImageCount(res.data.imageCount)
      } else {
        console.log('Error:', res.data)
        message.error(res?.data?.message)
      }
    })
  }

  const showUpload = () => {
    getImageCount()
    setUpLoadVisible(!upLoadVisible)
  }

  useEffect(() => {
    getImageCount()
  }, [])

  return (
    <>
      <ImageModal
        action={action}
        editing={!submitted && (user.role.includes('ADMIN') || user.role.includes('DESIGNER') || user.role.includes('DESIGNER-DSB') || user.role.includes('DESIGNER-LEAD'))}
        itemId={itemId}
        orderId={orderId}
        headerId={headerId}
        visible={upLoadVisible}
        onCancel={() => { showUpload() }}
      />
      <Space>
        <FileImageOutlined />
        {imageCount || 0}
        <Divider type="vertical" orientation="center" />
        {
          !submitted && (user.role.includes('ADMIN') || user.role.includes('DESIGNER') || user.role.includes('DESIGNER-DSB') || user.role.includes('DESIGNER-LEAD'))
            ? (
              <Tooltip placement="top" title="Upload Image">
                <Button
                  shape="circle"
                  icon={<UploadOutlined />}
                  onClick={() => { showUpload() }}
                />
              </Tooltip>
            )
            : (
              <Tooltip placement="top" title="View Image">
                <Button
                  shape="circle"
                  icon={<EyeOutlined />}
                  onClick={() => { showUpload() }}
                />
              </Tooltip>
            )
        }
      </Space>
      {/* { action === 'Header'
        ? (
          <Space>
            <FileImageOutlined />{imageList !== null && imageList !== undefined ? imageList : 0}
            <Divider type="vertical" orientation="center" />
            <Button icon={<UploadOutlined />} onClick={() => { showUpload() }}>
              Upload
            </Button>
          </Space>
        )
        : (
          <Row justify="center" style={{ alignItems: 'center' }}>
            <Col style={{ textAlign: 'left' }} md={8}>
              <Tooltip placement="top" title={`${imageList !== null && imageList !== undefined ? imageList : 0} items`}>
                <Space>
                  <FileImageOutlined />
                  {imageList !== null && imageList !== undefined ? imageList : 0}
                </Space>
              </Tooltip>
            </Col>
            <Divider type="vertical" orientation="center" />
            <Col md={8}>
              <Tooltip placement="top" title="Upload Image">
                <Button
                  shape="circle"
                  icon={<UploadOutlined />}
                  onClick={() => { showUpload() }}
                />
              </Tooltip>
            </Col>
          </Row>
        )} */}

    </>
  )
}

export default UploadButton
